import { render, staticRenderFns } from "./media-sosial.vue?vue&type=template&id=0672049b"
import script from "./media-sosial.vue?vue&type=script&lang=js"
export * from "./media-sosial.vue?vue&type=script&lang=js"
import style0 from "./media-sosial.vue?vue&type=style&index=0&id=0672049b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports